<template>
  <transition-group tag="ul" class="zk-upload__files" name="list">
    <li
      v-for="file in files"
      class="zk-upload__file"
      :class="{
        'is-finished': file.status === 'finished'
      }"
      :key="file"
      @click="$emit('clickFile', file)"
    >
      <a class="zk-upload__file__name" @click="$emit('preview', file)">
        <i class="zk-icon-document"></i>{{file.name}}
      </a>
      <span class="zk-upload__btn-delete" @click="$emit('remove', file)" v-show="file.status === 'finished'">{{ t('el.upload.delete') }}</span>
      <zk-progress
        v-if="file.showProgress"
        :stroke-width="2"
        :percentage="parsePercentage(file.percentage)"
        :status="file.status === 'finished' && file.showProgress ? 'success' : ''">
      </zk-progress>
    </li>
  </transition-group>
</template>
<script>
  import Locale from 'theme/mixins/locale';

  export default {
    mixins: [Locale],
    props: {
      files: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    methods: {
      parsePercentage(val) {
        return parseInt(val, 10);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// upload-list.vue?130eaddb